module.exports = __webpack_public_path__ + "images/108_1024.jpg";